import { Component, HostBinding } from '@angular/core';

/**
 * ラベルtooltipコンポーネント
 */
@Component({
  templateUrl: './label-view.component.html',
  styleUrls: ['./label-view.component.scss']
})
export class LabelViewComponent {

  displayValue = '';

  tooltip = '';

  @HostBinding('style.width') width = '100%';

  agInit(params: any) {
    if (params.value) {
      this.displayValue = params.value;
      this.tooltip = this.displayValue;
    } else {
      params.value = {};
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/page/contact-list-page/label/label-view.component.ts